export default {
  heading1: 'Yangiliklar',
  heading: "So'ngi yangiliklar",
  readMore: 'Batafsil'
}